import { createContext, useContext } from 'react';
import type { DialogRef } from './dialogService';

/** Lets DialogClose find its dialog without prop drilling (Angular's `mat-dialog-close` did the same via DI). */
export const DialogRefContext = createContext<DialogRef<never> | null>(null);

export function useDialogRef<R>(): DialogRef<R> {
  const ref = useContext(DialogRefContext);
  if (!ref) throw new Error('DialogClose must be rendered inside a dialog opened with openDialog().');
  return ref as unknown as DialogRef<R>;
}
